import CategoryParentReferenceResourceModel from '../../generated/types/model/resource/CategoryParentReferenceResourceModel';

export default class CategoryParentReferenceResourceViewModel extends CategoryParentReferenceResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
